import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
// redux
import { selectAuthReset } from 'redux/auth/authSelectors';
// components
import ResetPasswordForm from 'components/forms/ResetPasswordForm/ResetPasswordForm';

const ResetPasswordPage = () => {
  const authReset = useSelector(selectAuthReset);
  const navigate = useNavigate();

  useEffect(() => {
    if (authReset) navigate("/login", { replace: true }); 
    else if (authReset === null) navigate("/recovery", { replace: true });
  }, [authReset, navigate])
  
  return (
    <main className="auth-page">
      <section className="auth">
        <div className="auth__container">
          <h1 className="auth__title">Зміна паролю</h1>
          <strong className="auth__msg auth__msg--recovery"> Введіть новий пароль </strong>
          <ResetPasswordForm />
        </div>
      </section>
    </main>
  );
};

export default ResetPasswordPage;